import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'hidden',
  backgroundColor: 'white',
  flexGrow: 1,
}));
export default StyledBox;
